<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { computed, onMounted, watch } from 'vue'
import _ from 'lodash'
import RealestateDetail from '@/modules/realestate/views/RealestateDetail.vue'
import {
  AssetsListActionTypes,
  useAssetsListStore,
} from '@/modules/realestate/stores/assets.list.store.ts'

const assetsListStore = useAssetsListStore()

const pageTabs = computed(() => {
  return assetsListStore.tabs
})
const displayTabContent = computed(() => {
  return assetsListStore.tabs?.find((tab) => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return assetsListStore.tableConfig
})
const filter = computed(() => {
  return assetsListStore.filter
})
const loading = computed(() => {
  return assetsListStore.action_type == AssetsListActionTypes.FETCHING
})
const page = computed(() => {
  return assetsListStore.page
})
const pageSize = computed(() => {
  return assetsListStore.pageSize
})
const dataSource = computed<any>(() => {
  return assetsListStore.data
})

const handleChangeTab = (tab: any) => {
  assetsListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {
  assetsListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  assetsListStore.closeAllTab()
}

const handleChangePage = (page: number) => {
  assetsListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {
  assetsListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {
  assetsListStore.setFilter(filter)
}

const handleRowDblClick = (e: MouseEvent, item: any) => {
  assetsListStore.newTab({
    id: item.code,
    label: `#${item.code} - ${[item.address, item.district?.name, item.province?.name].filter(Boolean).join(' ,')}`,
    active: true,
  })
}

const handleChangeSelectedRow = (ids: Array<string | number>) => {
  console.log('handleChangeSelectedRow', ids)
}

const handleSort = (field: string, direction: string) => {
  assetsListStore.toggleSort(field, direction)
}

const requestFetchAssetList = _.debounce(async () => {
  try {
    await assetsListStore.fetchList()
  } catch (e) {}
}, 500)

watch(
  () => assetsListStore.uuid,
  () => {
    requestFetchAssetList()
  },
)

onMounted(() => {
  assetsListStore.changeTab('list')
  if (assetsListStore.action_type === AssetsListActionTypes.PENDING) requestFetchAssetList()
})
</script>

<template>
  <dashboard-layout
    currentRoute="property/items"
    page-title="Danh sách tài sản"
    :tabs="pageTabs"
    :tabsEvent="{
      close: handleCloseTab,
      select: handleChangeTab,
      closeAll: handleCloseAllTab,
    }"
  >
    <template v-if="displayTabContent == 'list'">
      <filter-list :filter="filter" @update:filter="handleUpdateFilter" />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"
        :row-action-buttons="[
          {
            action: handleRowDblClick,
            css: 'btn btn-cs',
            label: 'Chi tiết',
            icon: 'iconamoon:edit-duotone',
          },
        ]"
        primaryField="code"
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="assetsListStore.toggleColumnVisibility"
        @on-selected-row="handleChangeSelectedRow"
        @on-sort="handleSort"
      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <realestate-detail :id="tab.id" :key="tab.id" />
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
